// Registers the ZeroMargin service worker (public/sw.js).
// Graceful: any failure is swallowed so the app keeps working without a SW.
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register on secure contexts (https / localhost).
  if (!window.isSecureContext) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/sw.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // When a new SW takes control, reload once so users get the latest build
        // (prevents being stuck on an old cached version).
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });

        // If an updated SW is found and finishes installing while a controller
        // already exists, ask it to activate immediately.
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              reg.waiting && reg.waiting.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {
        /* graceful: app works without SW */
      });
  });
}
